import React from 'react';
import { motion } from 'framer-motion';
import { productById } from '../data/products';
import { ProductGlyph } from './ui/ProductGlyph';
interface ProductPanelProps {
  productId: string;
  accent: string;
  eyebrow?: string;
}

/** The product only appears once the clinical need has been established. */
export function ProductPanel({
  productId,
  accent,
  eyebrow = 'Filtek solution'
}: ProductPanelProps) {
  const product = productById(productId);
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="relative overflow-hidden border border-enamel/10 bg-enamel/[0.03] p-6 backdrop-blur-sm sm:p-8" data-id="element-107" data-mp="2fecg2m6d8pmn">
      <div className="absolute inset-x-0 top-0 h-px" style={{
      backgroundColor: accent
    }} aria-hidden="true" data-id="element-108" data-mp="2bfddh883x4yd" />
      <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:gap-9" data-id="element-109" data-mp="21go5q89xd0vu">
        <ProductGlyph form={product.form} accent={accent} className="h-32 w-16 shrink-0 sm:h-44 sm:w-20" data-id="element-110" data-mp="21is6ihcj1jrw" />

        <div className="min-w-0 flex-1" data-id="element-111" data-mp="fwgyeuar0lzz">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-112" data-mp="fvfmyoptlxhq">
            <p className="label-mono text-[10px]" style={{
            color: accent
          }} data-id="element-113" data-mp="tufblwdc2cdw">
              {eyebrow}
            </p>
            <span className="label-mono border px-2 py-1 text-[8px]" style={{
            borderColor: `${accent}55`,
            color: accent
          }} data-id="element-114" data-mp="pud6fd8e30tv">
              {product.role === 'cousin' ? 'The cousin' : 'Family member'}
            </span>
          </div>

          <h4 className="mt-3 text-2xl font-normal leading-tight tracking-[-0.01em] text-enamel sm:text-[1.9rem]" data-id="element-115" data-mp="axmhjxwcd7ii">
            {product.name}
          </h4>
          <p className="mt-3 max-w-lg text-base font-light leading-relaxed text-mute" data-id="element-116" data-mp="641j64qu6bis">
            {product.claim}
          </p>

          <dl className="mt-7 grid gap-x-8 gap-y-4 sm:grid-cols-2" data-id="element-117" data-mp="3akvvx2b69w9z">
            {product.facts.map(fact => <div key={fact.label} className="border-t border-enamel/10 pt-3" data-id="element-118" data-mp="1diez6vfl708n">
                <dt className="label-mono text-[9px] text-mute/70" data-id="element-119" data-mp="1ii17qrkgzsb4">{fact.label}</dt>
                <dd className="mt-1.5 text-sm font-light text-enamel" data-id="element-120" data-mp="1n9jclqpm6d1d">{fact.value}</dd>
              </div>)}
          </dl>

          <p className="mt-6 text-sm font-light italic text-mute" data-id="element-121" data-mp="1s7b5oo1zw575">{product.kinship}</p>
        </div>
      </div>
    </motion.div>;
}